module.exports = __webpack_public_path__ + "static/img/mobilebanner4.e62fc49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilebanner4.png
// module id = GKdi
// module chunks = 1